import React from "react";

interface LoadingSpinnerProps {
  textToDisplay: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ textToDisplay }) => {
  return (
    <section>
      <div className="mx-auto px-3 py-5 py-lg-5 sec-wrapper">
        <div className="text-center">
          <p className="fs-6 fs-md-5 text-primary-custom">{textToDisplay}</p>
        </div>
      </div>
    </section>
  );
};

export default LoadingSpinner;
